import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { PhoneForwarded, Loader2 } from "lucide-react";

const fmt = (p) => { const d = (p || "").replace(/\D/g, "").slice(-10); return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : p; };

export const TestTransferCard = () => {
  const [next, setNext] = useState(undefined);
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/live-transfers/next").then((r) => setNext(r.data.mlo)).catch(() => setNext(null)); }, []);
  const ring = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/live-transfers/test", { caller_phone: phone });
      toast.success(`Ava is calling ${fmt(phone)} now - answer it and she'll forward you to ${data.mlo_name} at ${fmt(data.mlo_phone)}`);
    } catch (e) { toast.error(apiError(e)); }
    setBusy(false);
  };
  return (
    <Card className="mb-5 p-6" data-testid="test-transfer-card">
      <h3 className="mb-1 flex items-center gap-2 font-display text-lg font-bold text-slate-900"><PhoneForwarded className="h-5 w-5" />Test a live transfer</h3>
      <p className="mb-3 text-sm text-slate-600" data-testid="test-transfer-next">
        {next === undefined ? "Checking who's next in line…" : next
          ? <>The next live transfer goes to <b>{next.name}</b> at <b>{fmt(next.phone)}</b>{next.free ? " (free)" : ` ($${next.price.toFixed(0)} per transfer)`}.</>
          : "No MLO is eligible for live transfers right now - turn on Receive live transfers, add a phone, and have at least $100 in the balance."}
      </p>
      <p className="mb-3 text-xs text-slate-500">Enter a second phone that plays the caller. Ava calls it and immediately forwards it to the MLO's phone, just like a real transfer. No charge.</p>
      <div className="flex flex-col gap-2 sm:flex-row">
        <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Caller phone, e.g. 407-555-0123" className="sm:max-w-xs" data-testid="test-transfer-phone" />
        <Button onClick={ring} disabled={busy || !next || phone.replace(/\D/g, "").length < 10} data-testid="test-transfer-btn">
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <PhoneForwarded className="mr-2 h-4 w-4" />}Ring test transfer
        </Button>
      </div>
    </Card>
  );
};
